export default "__VITE_ASSET__B3OXKd3I__"